module.exports = __webpack_public_path__ + "static/media/class_yellow.c939d1a7.svg";